import React from 'react';

function Filter(props) {
  return (
    <fieldset
      className={"filter " + props.label}
      >
      <legend className="filter-legend">{props.label}:</legend>
      {props.options.map( item => (
        <label 
          key={item.value}
          className="filter-item"
          >
          <input 
            type="radio"
            className="filter-radio"
            name={props.label}
            value={item.value}
            defaultChecked={item.value === props.value}
            onChange={(event) => {
              if(event.target.checked){
                props.onChange(event.target.value);
              }
            }}
            />
          <span
            className="filter-label"
            >{item.label}</span>
        </label>
        ))}
    </fieldset>
  );
}

export default Filter;